import client from './client';

export const teamsApi = {
  // ==================== TEAMS ====================

  /**
   * Get all teams the user belongs to
   */
  async getTeams() {
    const { data } = await client.get('/api/teams');
    return data;
  },

  /**
   * Create a new team
   */
  async createTeam(teamData) {
    const { data } = await client.post('/api/teams', teamData);
    return data;
  },

  /**
   * Get a specific team
   */
  async getTeam(id) {
    const { data } = await client.get(`/api/teams/${id}`);
    return data;
  },

  /**
   * Update a team
   */
  async updateTeam(id, teamData) {
    const { data } = await client.patch(`/api/teams/${id}`, teamData);
    return data;
  },

  /**
   * Delete (archive) a team
   */
  async deleteTeam(id) {
    const { data } = await client.delete(`/api/teams/${id}`);
    return data;
  },

  // ==================== MEMBERS ====================

  /**
   * Get team members
   */
  async getMembers(teamId) {
    const { data } = await client.get(`/api/teams/${teamId}/members`);
    return data;
  },

  /**
   * Add a member directly (admin only)
   */
  async addMember(teamId, userId, role = 'member') {
    const { data } = await client.post(
      `/api/teams/${teamId}/members`,
      { userId, role }
    );
    return data;
  },

  /**
   * Update a member's role
   */
  async updateMemberRole(teamId, userId, role) {
    const { data } = await client.patch(
      `/api/teams/${teamId}/members/${userId}`,
      { role }
    );
    return data;
  },

  /**
   * Remove a member from the team
   */
  async removeMember(teamId, userId) {
    const { data } = await client.delete(
      `/api/teams/${teamId}/members/${userId}`
    );
    return data;
  },

  /**
   * Transfer team ownership
   */
  async transferOwnership(teamId, userId) {
    const { data } = await client.post(
      `/api/teams/${teamId}/transfer-ownership`,
      { userId }
    );
    return data;
  },

  // ==================== INVITATIONS ====================

  /**
   * Get pending invitations for the current user
   */
  async getPendingInvitations() {
    const { data } = await client.get('/api/teams/invitations/pending');
    return data;
  },

  /**
   * Get pending invitations for a team
   */
  async getTeamInvitations(teamId) {
    const { data } = await client.get(`/api/teams/${teamId}/invitations`);
    return data;
  },

  /**
   * Invite a user to a team
   */
  async inviteUser(teamId, inviteData) {
    const { data } = await client.post(
      `/api/teams/${teamId}/invitations`,
      inviteData
    );
    return data;
  },

  /**
   * Accept a team invitation
   */
  async acceptInvitation(invitationId) {
    const { data } = await client.post(
      `/api/teams/invitations/${invitationId}/accept`
    );
    return data;
  },

  /**
   * Decline a team invitation
   */
  async declineInvitation(invitationId) {
    const { data } = await client.post(
      `/api/teams/invitations/${invitationId}/decline`
    );
    return data;
  },

  /**
   * Cancel/revoke an invitation
   */
  async cancelInvitation(teamId, invitationId) {
    const { data } = await client.delete(
      `/api/teams/${teamId}/invitations/${invitationId}`
    );
    return data;
  },

  // ==================== USER SEARCH ====================

  /**
   * Search for users to invite (by email)
   */
  async searchUsers(email, teamId = null) {
    const params = { email };
    if (teamId) {
      params.teamId = teamId;
    }
    const { data } = await client.get('/api/teams/users/search', { params });
    return data;
  },

  /**
   * Get available team roles
   */
  async getTeamRoles() {
    const { data } = await client.get('/api/teams/roles');
    return data;
  },
};
